// extracted by mini-css-extract-plugin
module.exports = {"row":"_8s8wizG7pFAWw-DM10i0j","dot":"_1TXUbQlSHzIxvnHrN5WAob","typing":"_3TBB6qpas4wVBZWBKVDaH_"};